import * as React from 'react';

import { useSelector } from 'react-redux';
import { Ecology } from '../../components/Ecology';
import { getEcology } from '../../selectors/newbuilding';

export function EcologyContainer() {
  const ecology = useSelector(getEcology);

  if (!ecology || !ecology.length) {
    return null;
  }

  return <Ecology ecology={ecology} />;
}
